import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import { YYYY_MM_DD } from "constants/date";
import dayjs from "dayjs";
import { Field, FieldProps, Form, Formik } from "formik";
import { useToast } from "hooks/useToast";
import { useUpdateTaskAssigneeAdminMutation } from "store/apis/serviceTeam";
import { Task1120Tracker } from "types/Models/TaskTracker";

export const ReviewStartDateColumn = ({ row }: { row: Task1120Tracker }) => {
  const [updateTaskAssignee] = useUpdateTaskAssigneeAdminMutation();
  const { alertToast, successToast } = useToast();

  const handleDateChange = async (date: Date) => {
    try {
      await updateTaskAssignee({
        taskId: row.task_uuid,
        review_start_date: dayjs(date).format(YYYY_MM_DD),
      }).unwrap();
      successToast({ message: "Review start date updated" });
    } catch (error: any) {
      alertToast({ message: error?.data?.error?.message });
    }
  };

  const taskId = row.task_uuid;
  const oneYearAgo = dayjs().subtract(1, "year").toDate();

  return (
    <Formik
      onSubmit={() => {}}
      initialValues={{ review_start_date: row.review_start_date }}
    >
      {({ setFieldValue }) => (
        <Form className="t-w-full t-m-0" onClick={(e) => e.stopPropagation()}>
          <Field name="review_start_date">
            {({ field }: FieldProps) => (
              <DateInput
                {...field}
                portalId={"review_start_date_portal" + taskId}
                onDateChange={(date) => {
                  setFieldValue("review_start_date", date);
                  handleDateChange(date);
                }}
                minDate={oneYearAgo}
              />
            )}
          </Field>
        </Form>
      )}
    </Formik>
  );
};
